import React from 'react';
import { Mark, mergeAttributes } from '@tiptap/core';
import { getAttrs, renderHTMLAttrs, TEMPLATE_VALUE_ATTRIBUTE } from './TemplateValue';

export const CustomSpan = Mark.create({
	name: 'customSpan',
	addAttributes() {
		return {
			...TEMPLATE_VALUE_ATTRIBUTE,
			class: {
				default: null,
			},
			style: {
				default: null,
				parseHTML: (element) => element.getAttribute('style'),
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},
		};
	},
	parseHTML() {
		return [
			{
				tag: 'span',
				getAttrs: (element) => {
					const className = element.getAttribute('class');
					return {
						...getAttrs(element),
						class: className,
						style: element.getAttribute('style'),
					};
				},
			},
		];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			'span',
			mergeAttributes(renderHTMLAttrs({ HTMLAttributes, editor: this.editor })),
			0,
		];
	},
});
export default CustomSpan;
